import React, { useEffect, useState } from "react";
 
import { useNavigate, useParams } from "react-router-dom";
import NoticeDetails from "./NoticeDetails";
import { useCreatemessageMutation, useDeletemessageMutation, useLazyFetchmessageQuery, useUpdatedemandemessageMutation } from "../../../redux/slice/api/FO/messageApi";
import { MessageTypeDemande, MessageTypeView, ModificationBloque, Type_Reponse_Message } from "../../../config/helpers";
import { useKeycloak } from "@react-keycloak/web";
import MessageView from "../components/message/MessageView";
import NoticeDetailsPreview from "./NoticeDetailsPreview";
import { IFormMessageDemande } from "../../../components/IFormMessage";
import { Type_Return_Message } from "../../../models/interfaces/IReturn_Parent";
import { toast } from "react-toastify";
import { IMessage } from "../../../models/interfaces/IMessage";
import { useFetchNoticeQuery } from "../../../redux/slice/api/FO/noticeApi";
import CpntDetailsNotAccess, { TypeAffichage } from "../../../components/CpntDetailsNotAccess";
import SpinnerEditeurPro from "../components/SpinnerEditeurPro";
import CpntNavigatorNotice from "../components/CpntNavigatorNotice";

const PageNoticeDetailsMessageDemande: React.FC = () => {
  const [Actif, setActif] = useState(false);
  const [IdMessage, setIdMessage] = useState<number|null>(null);
  const [message, setMessage] = useState<IMessage|null>(null);
  const [pathSource, setPathSource] = useState<string>("");

  const detail = () => {
    setActif(!Actif);
  }



  const navigate = useNavigate();
  const { ean:eanUrl, idnotice:idnoticeUrl,idmessage:idmessageUrl } = useParams();
  const eanValue = eanUrl ?? "";
  const idnoticeValue = idnoticeUrl ?? "";
  const idmessageValue = idmessageUrl ?? "";
  const { initialized: keycloakinitialized,keycloak } = useKeycloak();
  

  useEffect(() => {
    const pathParts = location.pathname.split("/").filter(Boolean); // Supprime les éventuels espaces vides

    if (pathParts.length >= 1 ) {
      setPathSource(`/${pathParts[0]}`);

      }
  }, [location.pathname, navigate]);


  //const [triggerGetMessages, { data: MessagesResult, isFetching: isFetchingMessages, error: Messageserror }] = useLazyFetchmessages_ByEanQuery();
  const [triggerGetMessage, { data: MessageResult, isFetching: isFetchingMessage, error: Messageerror }] = useLazyFetchmessageQuery();


  const { data: NoticeResult, isFetching: isFetchingNoticeResult } = useFetchNoticeQuery({ EAN: eanValue, IdNotice: idnoticeValue }, {
    refetchOnMountOrArgChange: true,
    skip: !keycloakinitialized || !keycloak.authenticated || eanValue === null || eanValue === "" ,
  });

  const ModificationMessageBloqueMessage = ModificationBloque(
    NoticeResult?.NoticeDetails?.Source ?? "",
    NoticeResult?.NoticeDetails?.Support?.supportId ?? "",
    "Modifcations par message impossible pour cette notice.");


  useEffect(() => {
    MessageResult?.Message && setMessage(MessageResult?.Message);
  }, [MessageResult])


  useEffect(() => {
    !isNaN(Number(idmessageValue)) && setIdMessage(Number(idmessageValue));
  }, [idmessageValue]);


  useEffect(() => {
    if (keycloakinitialized && keycloak.authenticated && IdMessage) {
      triggerGetMessage(IdMessage);
    }
  }, [keycloakinitialized, keycloak.authenticated, IdMessage, triggerGetMessage]);

  const [
    updateDemandeMessage,
    {
    //isSuccess: isSuccessUpdatedemandeMessage,
    error: errorUpdatedemandeMessage,
    reset: resetUpdatedemandeMessage
  }] = useUpdatedemandemessageMutation();

  const [
    createDemandeMessage,
    {
    //isSuccess: isSuccessCreatedemandeMessage,
    error: errorCreatedemandeMessage,
    reset: resetCreatedemandeMessage
  }] = useCreatemessageMutation();


  const [
    deleteMessage, {
    //isSuccess: isSuccessDeleteMessage,
    error: errorDeleteMessage,
    reset: resetDeleteMessage
  }] = useDeletemessageMutation();


  
  const handleSupprimerDemande = async (idMessage:number) => {

    const response = await deleteMessage(idMessage).unwrap();
    if (response.Return_IdType_Message === Type_Return_Message.Erreur) {
      resetDeleteMessage();
      response.Return_Message &&
      toast.error(<div dangerouslySetInnerHTML={{ __html: response.Return_Message }} />,{autoClose:5000});
    } else if (response.Return_IdType_Message === Type_Return_Message.Validation) {
      setMessage(null);
      resetDeleteMessage();
      toast.success("La demande a été supprimée avec succès");
      navigate(`${pathSource}`, { replace: true });
      //navigate(`${pathSource}/noticedetails/noticedetailsmessage/${eanValue}/${idnoticeValue}`, { replace: true });
    }
  }

  const handleCreateDemande = async (data:IFormMessageDemande) => {
        const response = await createDemandeMessage(
          {
            IdTypeDemande: data.IdTypeDemande?? -1,
            MessageDemande:data.MessageDemande,
            Ean:eanValue,
            NoticeMarques:NoticeResult?.NoticeDetails?.Editeurs.map(e => Number(e.editeurId.replace(/^0-7/, ''))),
            IdNotice:idnoticeValue
          }
        ).unwrap();
     
        if (response.Return_IdType_Message === Type_Return_Message.Erreur) {
          resetCreatedemandeMessage();
          response.Return_Message &&
          toast.error(<div dangerouslySetInnerHTML={{ __html: response.Return_Message }} />,{autoClose:5000});
        } else if (!isNaN(Number(response?.Message.Id))) {
          setMessage(response?.Message);
          resetCreatedemandeMessage();
          toast.success(<div dangerouslySetInnerHTML={{ __html: "Votre demande de correction a bien été prise en compte." }} />);

          //reiniitalise
          setTimeout(() => {
            setMessage(null);
          }, 1000);
       
          
          //contextualisé ?
          //navigate(`${pathSource}/noticedetails/${eanValue}/${idnoticeValue}`, { replace: true });
          //navigate(`${pathSource}/noticedetails/noticedetailsmessage/${eanValue}/${idnoticeValue}`, { replace: true });
          //navigate(`${pathSource}/noticedetails/noticedetailsmessage/${eanValue}/${idnoticeValue}/${response?.Message?.Id}`, { replace: true });
          
        }

      //}
  }
  
  const handleUpdateDemande = async (data:IFormMessageDemande) => {

    //if (MessageResult !== undefined && MessageResult?.Id !== undefined && MessageResult.Id > 0) {
      if (message && message?.Id !== undefined && message.Id > 0) {
     //UPDATE
     const response = await updateDemandeMessage(
       {
         //...data,
         Id:message && message.Id ? message.Id : -1,
         IdTypeDemande: data.IdTypeDemande?? -1,
         MessageDemande:data.MessageDemande,
         Ean:eanValue,
         NoticeMarques:NoticeResult?.NoticeDetails?.Editeurs.map(e => Number(e.editeurId.replace(/^0-7/, ''))),
         IdNotice:idnoticeValue
       }
     ).unwrap();

     if (response.Return_IdType_Message === Type_Return_Message.Erreur) {
      resetUpdatedemandeMessage();
      response.Return_Message &&
       toast.error(<div dangerouslySetInnerHTML={{ __html: response.Return_Message }} />,{autoClose:5000});
     } else if (!isNaN(Number(response?.Message.Id))) {
       setMessage(response?.Message);
       resetUpdatedemandeMessage();
       toast.success(<div dangerouslySetInnerHTML={{ __html: "Votre demande de correction a bien été prise en compte." }} />,);
       navigate(`${pathSource}/noticedetails/noticedetailsmessage/${eanValue}/${idnoticeValue}/${response?.Message?.Id}`, { replace: true });
       //navigate(`${pathSource}/noticedetails/noticedetailsmessage/${eanValue}/${idnoticeValue}/${response?.Message?.Id}`, { replace: true });
     }

     }
  }

  const getNavigator = () => {
    return (
    <div className="col-3 mt-2 d-flex justify-content-end">
    <div className="me-2">
    <CpntNavigatorNotice
    currentValueEan={eanValue}//NoticeResult?.NoticeDetails?.Ean}
    currentValueIdNotice={idnoticeValue}//NoticeResult?.NoticeDetails?.Id}
    currentValueIdMessage={idmessageValue}//MessageResult?.Message?.Id}
    datas={(() => {
      const storedData = localStorage.getItem("NoticesNavigator");
      try {
        const parsedData = storedData ? JSON.parse(storedData) : [];
        return Array.isArray(parsedData) ? parsedData : [];
      } catch {
        return [];
      }
    })()}
    />
    </div>
  </div>
    )
  }


  const getNonAccessibleNoticePart = (message?: string) => {
    return (
      <CpntDetailsNotAccess text={message} typeAffichage={TypeAffichage.Notice} />
    )
  }
 
  const getNonAccessibleFormPart = (jsxContent?: JSX.Element) => {
    return (
      <div className="container">
      <div className="card pae-detail-pub-card mt-2 alert alert-danger" role="alert">
          <div className="card-body pae-form-container row">
            <div className="col-12">
              {jsxContent}
            </div>
          </div>
      </div>
    </div>
    )
  }





  if (errorUpdatedemandeMessage || errorCreatedemandeMessage || errorDeleteMessage) {
    //
  } 

  if (Messageerror) {
    return (
      <div>Error</div>
    );
  } 

  if (isFetchingMessage || isFetchingNoticeResult) {
    return (
      <SpinnerEditeurPro />
    )
  }
  
  return (
    NoticeResult ?
    <>
      {
      <>
      <div className="container">
      <div className="row">
          <div className="col-9 mt-2 d-flex justify-content-start">
            {
              message && message?.Id ?
              <>Votre contact :&nbsp;<b>{message?.SuiviPar ? message?.SuiviPar : 'biblio@electre.com'}</b></>
              :
              <>Votre contact :&nbsp;<b>{NoticeResult?.NoticeDetails?.SuiviPar ? NoticeResult?.NoticeDetails?.SuiviPar : 'biblio@electre.com'}</b></>
            }
          </div>
          {
            getNavigator()
          }
        </div>
          {
          (NoticeResult?.Return_IdType_Message === Type_Return_Message.Erreur)?
          getNonAccessibleNoticePart("Cette demande est rattachée à une notice qui ne fait plus partie de votre périmètre de consultation")
          :
          // ModificationMessageBloqueMessage !== undefined ? 
          // getNonAccessiblePart(undefined,ModificationMessageBloqueMessage)
          // :
            !Actif ? 
              <>
                  <div className="row">
                      <div className="col-12 mt-2">
                        <NoticeDetailsPreview NoticeResult={NoticeResult?.NoticeDetails} isFetchingNoticeResult={isFetchingNoticeResult} btnModifierAutoVisible={idmessageValue ? false : true} btnModifierMessageVisible={false} ></NoticeDetailsPreview>
                      </div>
                  </div>
                  <div onClick={detail} style={{cursor:"pointer",backgroundColor:"#efefef"}} className="card btn btn-grey mt-1">
                    <div className="row">
                        <i className="col-12 bi-caret-down-fill"></i>
                    </div>
                  </div>
              </> 
              :  
              <>
                {/* navigatorPath="../noticedetailsmessage/" */}
                <NoticeDetails NoticeResult={NoticeResult?.NoticeDetails} isFetchingNoticeResult={isFetchingNoticeResult} btnModifierAutoVisible={idmessageValue ? false : true} btnModifierMessageVisible={false}></NoticeDetails>
                <div onClick={detail} style={{cursor:"pointer",backgroundColor:"#efefef"}} className="card btn btn-grey mt-1">
                  <div className="row">
                      <i className="col-12 bi bi-caret-up"></i>
                  </div>
                </div>
              </>
          }
        </div>
        {
          (NoticeResult?.Return_IdType_Message === Type_Return_Message.Erreur || ModificationMessageBloqueMessage !== undefined)
          && (!message?.Id || (message?.IdTypeReponse && message?.IdTypeReponse < Type_Reponse_Message.TraitementEnCours)) 
          ? getNonAccessibleFormPart(ModificationMessageBloqueMessage)
          :
          <div className="row mt-2" style={{ textAlign: 'left' }}>
            <MessageView key={`D${message?.Id ?? 'new'}`} supprimerDemande={handleSupprimerDemande} enregistrerDemande={message ? handleUpdateDemande : handleCreateDemande} Message={message ? message : undefined} typeView={MessageTypeView.Demande} typeDemande={MessageTypeDemande.Notice} />
            <MessageView key={`R${message?.Id ?? 'new'}`} Message={message ? message : undefined} typeView={MessageTypeView.Reponse} typeDemande={MessageTypeDemande.Notice} />
          </div>
        } 
      </>
      }

    </>
       : <></>
  );

  
};
 
export default PageNoticeDetailsMessageDemande;
 